import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportDetailsComponent } from '../passport-details/passport-details.component';
import { Router } from '@angular/router';
import { PassportDetailsStore } from '../shared/passport-details.store';
import { UiStateService } from '../shared/ui-state.service';
import { BasePassportCellComponent } from '../shared/base-passport-cell.component';
import { AuditListSnapshotBridgeService } from './audit-list-state.storage';

@Component({
  selector: 'app-audit-passport-cell',
  standalone: true,
  imports: [CommonModule, PassportDetailsComponent],
  templateUrl: '../shared/passport-cell.template.html',
  styleUrl: './audit-passport-cell.component.css'
})
export class AuditPassportCellComponent extends BasePassportCellComponent {
  protected get personaName(): string {
    return 'audit';
  }

  constructor(
    router: Router,
    details: PassportDetailsStore,
    ui: UiStateService,
    private readonly auditSnapshotBridge: AuditListSnapshotBridgeService
  ) {
    super(router, details, ui);
  }

  override openDetails(): void {
    const id = this.getRecordId('unknown');
    const existing = this.details.get(id);
    if (!existing) {
      this.details.upsert(this.getDetailsData(id));
    }
    this.auditSnapshotBridge.beforeNavigateToPassportDetails(id);
    this.ui.setExpandedRecord(id);
    this.scrollPositionService.saveScrollPosition('/audit');
    this.scrollPositionService.setReturningFromDetail(true);
    void this.router.navigate(['/passport', id], { state: { from: 'audit', tab: 'all' } });
  }

  override openComments(): void {
    const id = this.getRecordId();
    const header = this.createPassportHeader();
    const isDesktop = globalThis.window !== undefined && globalThis.window.innerWidth >= 768;

    if (isDesktop) {
      this.commentsPanelService.openCommentsPanel(id, header, true);
    } else {
      this.scrollPositionService.saveScrollPosition(`/${this.personaName}`);
      this.scrollPositionService.setReturningFromDetail(true);
      void this.router.navigate(['/comments'], { state: { passportId: id, header, readOnly: true } });
    }
  }
}
